import { render, staticRenderFns } from "./ParallelContainer.vue?vue&type=template&id=09d3c4f0&scoped=true&"
import script from "./ParallelContainer.vue?vue&type=script&lang=js&"
export * from "./ParallelContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d3c4f0",
  null
  
)

component.options.__file = "ParallelContainer.vue"
export default component.exports